import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=7e449610&scoped=true"
import script from "./gift.vue?vue&type=script&lang=js"
export * from "./gift.vue?vue&type=script&lang=js"
import style0 from "./gift.vue?vue&type=style&index=0&id=7e449610&prod&lang=stylus&scoped=true"
import style1 from "./gift.vue?vue&type=style&index=1&id=7e449610&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e449610",
  null
  
)

export default component.exports